import React, { useEffect } from "react";
import { AppBar, ButtonBase, Button, IconButton } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { GREY_300, WHITE } from "assets/theme/colors";
import { ReactComponent as LogoTripiPartner } from "assets/icons/tripipartnerlogo.svg";
import { ReactComponent as IcCloseSearch } from "assets/icons/ic_close_actionbar.svg";
import { ReactComponent as IcSearch } from "assets/icons/ic_search.svg";
import { snackbarSetting } from "modules/common/Elements";
import { Row } from "modules/common/Elements";
import SearchBox from "modules/component/SearchBox/SearchBox";
import { some, SUCCESS_CODE } from "constants/constants";
import { actionGetBookerInfo } from "modules/component/Booker/bookerAction";
import { checkDeviceType, isEmpty } from "utils/helpers/helpers";
import { useSnackbar } from "notistack";
import MobileSearchBox from "modules/component/SearchBox/MobileSearchBox";

//TODO: refactor to mobile header and desktop header
interface Props {
  history: some;
}
const MainHeader: React.FC<Props> = (props) => {
  const [results, setResults] = React.useState<some>({});
  const [hideLogo, setHideLogo] = React.useState<boolean>(false);
  const [expand, setExpand] = React.useState<boolean>(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const getBookerInfo = async (id: string) => {
    try {
      const res: some = await actionGetBookerInfo(id);
      if (res?.code === SUCCESS_CODE) {
        setResults(res?.data);
        if (!isEmpty(res?.data))
          //pass results props along the route
          props.history.push({ pathname: "/bookerInfo", state: res?.data });
      } else {
        enqueueSnackbar(
          res?.message,
          snackbarSetting((key) => closeSnackbar(key), { color: "error" })
        );
      }
    } catch (error) {}
  };
  useEffect(() => {
    const mobileBox = document.getElementById("navbar");
    mobileBox?.scrollIntoView(false);
  });
  return (
    <AppBar
      position="sticky"
      style={{
        height: "100%",
        padding: "10px",
        backgroundColor: WHITE,
        boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: 0,
        borderBottom: `1px solid ${GREY_300}`,
      }}
      id="navbar"
    >
      <Row
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {((checkDeviceType()?.device?.type === "mobile" && !expand) ||
          checkDeviceType()?.device?.type !== "mobile") && (
          <ButtonBase
            disableTouchRipple
            onClick={() => {
              props.history.push({ pathname: "/" });
            }}
            style={
              checkDeviceType()?.device?.type !== "mobile"
                ? { paddingLeft: 50 }
                : { paddingLeft: 12 }
            }
          >
            <LogoTripiPartner width="120" height="60" />
          </ButtonBase>
        )}

        <div
          style={
            expand
              ? {
                  margin: "0 auto",
                }
              : {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }
          }
        >
          {checkDeviceType()?.device?.type === "mobile" ? (
            <div
              style={{
                display: "flex",
              }}
            >
              {expand ? (
                <>
                  <Button onClick={() => setExpand(!expand)}>
                    <IcCloseSearch />
                  </Button>
                  <MobileSearchBox
                    results={results}
                    onSearch={getBookerInfo}
                    hideLogo={hideLogo}
                    setHideLogo={setHideLogo}
                  />
                </>
              ) : (
                <IconButton
                  size="small"
                  edge="start"
                  onClick={() => {
                    setExpand(!expand);
                    setHideLogo(!hideLogo);
                  }}
                >
                  <IcSearch />
                </IconButton>
              )}
            </div>
          ) : (
            <SearchBox onSearch={getBookerInfo} results={results} />
          )}
        </div>
      </Row>
    </AppBar>
  );
};

export default withRouter(MainHeader);
